// The Builder tab. A single scan-first flow (Setup → Discover → Activate) — the user
// never hand-picks conditions; the Discover step backtests every condition combination
// generated from the chosen indicators and the user selects a winning strategy.

import { WizardShell } from "./wizard/WizardShell";

export function BuilderPage() {
  // Width is controlled per-step inside WizardShell (the Discover step goes wide for its
  // list + chart split; Setup/Activate stay at a comfortable reading width).
  return (
    <div className="pb-12">
      <WizardShell />
    </div>
  );
}
